// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Scroll to top AFTER Turbo frame navigation completes
document.addEventListener('turbo:frame-load', (event) => {
  if (event.target.id === 'main_content') {
    // Use requestAnimationFrame to ensure DOM is fully rendered
    requestAnimationFrame(() => {
      window.scrollTo(0, 0)
    })
  }
})

// Also handle turbo:render for full page navigations
document.addEventListener('turbo:render', () => {
  window.scrollTo(0, 0)
})

// Réaligne le titre de l'onglet après une navigation dans le frame principal.
//
// Turbo ne met à jour le <title> que dans `mergeHead()`, appelée par
// PageRenderer. Or une navigation de frame avec `turbo_action: "advance"` passe
// `willRender: false` et le snapshot de la page *quittée*
// (`proposeVisitIfNavigatedWithAction`), si bien que le head n'est jamais
// fusionné : l'URL change, le titre reste celui de la page précédente. Un
// rechargement le corrige, puisque c'est alors un rendu de page complet.
//
// La réponse contient le document entier — Turbo n'en extrait le frame qu'après
// — donc le titre s'y trouve. `responseHTML` clone la réponse avant de la lire,
// la navigation n'est donc pas privée de son corps.
// Le titre est retenu ici puis appliqué au chargement du frame seulement : si
// la navigation échoue, l'onglet garde le titre de la page réellement affichée.
let titreEnAttente = null

document.addEventListener('turbo:before-fetch-response', async (event) => {
  if (event.target?.id !== 'main_content') return

  const response = event.detail?.fetchResponse
  if (!response?.contentType?.startsWith('text/html')) return

  const html = await response.responseHTML
  const balise = html?.match(/<title[^>]*>([\s\S]*?)<\/title>/i)?.[1]
  if (!balise) return

  // Décode les entités (&amp;, &nbsp;…) : un textarea détaché n'exécute rien
  // et expose le texte via `value`.
  const decodeur = document.createElement('textarea')
  decodeur.innerHTML = balise
  titreEnAttente = decodeur.value.trim()
})

document.addEventListener('turbo:frame-load', (event) => {
  if (event.target.id !== 'main_content') return

  if (titreEnAttente) {
    document.title = titreEnAttente
    titreEnAttente = null
  }
})
